import TabTempInspections from './TabTempInspections';

export default TabTempInspections;
